import {
  Alert,
  Autocomplete,
  Avatar,
  Backtop,
  Button,
  Card,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Divider,
  Empty,
  Form,
  FormItem,
  Image,
  Input,
  InputNumber,
  Link,
  Loading,
  Menu,
  MenuItem,
  Message,
  MessageBox,
  Notification,
  Option,
  PageHeader,
  Pagination,
  Popconfirm,
  Popover,
  Radio,
  RadioGroup,
  Row,
  Select,
  Switch,
  TabPane,
  Table,
  TableColumn,
  Tabs,
  Tag,
  Transfer,
  Tree,
  Upload
} from 'element-ui'

const components = [
  Alert,
  Autocomplete,
  Avatar,
  Backtop,
  Button,
  Card,
  Col,
  Collapse,
  CollapseItem,
  DatePicker,
  Dialog,
  Divider,
  Empty,
  Form,
  FormItem,
  Image,
  Input,
  InputNumber,
  Link,
  Menu,
  MenuItem,
  Option,
  PageHeader,
  Pagination,
  Popconfirm,
  Popover,
  Radio,
  RadioGroup,
  Row,
  Select,
  Switch,
  TabPane,
  Table,
  TableColumn,
  Tabs,
  Tag,
  Transfer,
  Tree,
  Upload
]

export default {
  install (Vue) {
    components.forEach(component => {
      Vue.use(component)
    })

    Vue.use(Loading.directive)

    Vue.prototype.$loading = Loading.service
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = Message
  }
}
